import { $getRoot, createEditor } from 'lexical';

export function plainTextToLexicalState(text: string): string {
  const lexicalEditor = createEditor({
    namespace: 'Editor',
    nodes: [],
    onError: console.error,
  });

  lexicalEditor.update(
    () => {
      const root = $getRoot();
      const selection = root.selectStart();
      selection?.insertRawText(text);
    },
    { discrete: true }
  );

  return JSON.stringify(lexicalEditor.getEditorState().toJSON());
}
